<mat-toolbar class="app-header" #header>
  <div class="left-content-wrapper">
    <a routerLink="/{{ lang }}/app">
      <img src="../../../../assets/img/logo/logo.png" alt="{{ configService.ownerNicename }}" height="30" class="d-none d-sm-inline-block">
      <img src="../../../../assets/img/logo/icon.png" alt="{{ configService.ownerNicename }}" height="30" class="d-inline-block d-sm-none">
    </a>
    <div class="d-inline-block" *ngIf="isIPICompany">
      <img src="../../../../assets/img/logo-IPI.jpg" alt="logo IPI CONDOMINIUM SRL" height="20">
    </div>
    <div class="d-inline-block" *ngIf="isDemoRoma">
      <img src="../../../../assets/img/logo-sara-servizi-secco.png" alt="logo Sara Servizi Secco" height="20">
    </div>
    <button mat-button (click)="toggleSidenav()">
      <mat-icon fontSet="fal" fontIcon="fa-bars"></mat-icon>
    </button>
  </div> <!-- /.left-content-wrapper -->

  <div class="right-content-wrapper">

    <button mat-mini-fab color="primary" matTooltip="{{ 'header.printer' | translate }}" class="d-none d-sm-inline-block" (click)="currentGlobal.print()">
      <mat-icon fontSet="fal" fontIcon="fa-print"></mat-icon>
    </button>
<!-- 
    <button mat-button [matMenuTriggerFor]="listsMenu" class="d-none d-sm-inline-block">
      <span class="d-none d-md-inline-block">{{ 'header.lists' | translate }}</span>
      <mat-icon fontSet="fal" fontIcon="fa-clipboard-list" class="d-md-none"></mat-icon>
      <mat-icon fontSet="fas" fontIcon="fa-caret-down" class="d-none d-md-inline-block"></mat-icon>
    </button>
    <mat-menu #listsMenu="matMenu" [hasBackdrop]="false">
      <button mat-menu-item routerLink="/{{ lang }}/app/users/list"
        routerLinkActive="active">{{ 'header.users' | translate }}</button>
      <button mat-menu-item routerLink="/{{ lang }}/app/permissions/list"
        routerLinkActive="active">{{ 'header.permissions' | translate }}</button>
      <button mat-menu-item routerLink="/{{ lang }}/app/roles/list"
        routerLinkActive="active">{{ 'header.roles' | translate }}</button>
      <button mat-menu-item routerLink="/{{ lang }}/app/companies/list"
        routerLinkActive="active">{{ 'header.companies' | translate }}</button>
      <button mat-menu-item routerLink="/{{ lang }}/app/properties/list"
        routerLinkActive="active">{{ 'header.properties' | translate }}</button>
    </mat-menu>
  -->
    <ng-container *ngIf="loggedUser && loggedUser._id">
      <button mat-button [matMenuTriggerFor]="userMenu">
        <span class="d-none d-sm-inline-block">{{ loggedUser.firstName }} - <small>{{ loggedUser.email }}</small></span>
        <mat-icon fontSet="fal" fontIcon="fa-user" class="d-sm-none"></mat-icon>
        <mat-icon fontSet="fas" fontIcon="fa-caret-down" class="d-none d-sm-inline-block"></mat-icon>
      </button>
      <mat-menu #userMenu="matMenu">
        <button mat-menu-item (click)="onViewProfile()" *ngIf="currentRoleType !== 'temporary' && currentRoleType !== 'shared'">{{ 'header.profile' | translate }}</button>
        <button mat-menu-item (click)="onLogout()">{{ 'header.logout' | translate }}</button>
      </mat-menu>
    </ng-container>
    <button mat-button [matMenuTriggerFor]="langMenu">
      {{ lang.toUpperCase() }}
      <mat-icon fontSet="fas" fontIcon="fa-flag"></mat-icon>
    </button>
    <mat-menu #langMenu="matMenu">
      <a mat-menu-item (click)="onSelectLang('en')" *ngIf="lang === 'it'">English</a>
      <a mat-menu-item (click)="onSelectLang('it')"  *ngIf="lang === 'en'">Italiano</a>
    </mat-menu>
  </div> <!-- /.right-content-wrapper -->
</mat-toolbar>
